import Text from '@components/Text/Text';
import { Menu, MenuItem, styled } from '@mui/material';

export const StyledMenu = styled(Menu)(({ theme }) => ({
  '.MuiPaper-root': {
    border: `1px solid ${theme.palette.grey.A100}`,
    borderRadius: theme.spacing(5),
    boxShadow: 'none',
  },
  '.MuiList-root': {
    padding: 0,
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.grey.A100,
  padding: theme.spacing(6, 10),
}));

export const MenuItemText = styled(Text)(({ theme }) => ({
  marginLeft: theme.spacing(10),
  marginRight: theme.spacing(16),
}));
